import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Detak Jantung Ideal Saat Berolahraga";
const DESCRIPTION =
  "Kalkulator detak jantung ideal: Tentukan rentang detak jantung target Anda untuk olahraga (pembakaran lemak, ketahanan kardiovaskular) berdasarkan usia dan intensitas latihan! Alat penting bagi atlet dan pelatih untuk memantau kesehatan jantung.";
const KEYWORDS = "detak jantung, olahraga, kebugaran fisik";
const OG_URL = "https://do-calculate.com/calculator/id/heartbeat-calculator/";
function HeartbeatCalculator() {
  const [age, setAge] = useState("");
  const [intensity, setIntensity] = useState(50);
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (age && intensity >= 0 && intensity <= 100) {
        const maxHeartRate = 220 - parseInt(age);
        const targetHeartRate = Math.round((maxHeartRate * intensity) / 100);
        const lowerBound = Math.round(maxHeartRate * 0.5);
        const upperBound = Math.round(maxHeartRate * 0.85);
        setResult({
          targetHeartRate,
          lowerBound,
          upperBound,
        });
      } else {
        throw new Error("Harap masukkan semua nilai dengan benar.");
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator ini menghitung detak jantung ideal saat berolahraga.
                </p>
                <p>Untuk menghitung hasil, harap masukkan usia dan intensitas latihan Anda.</p>
                <p>
                  Untuk menghitung detak jantung target, Anda harus menentukan detak jantung maksimal terlebih dahulu. Anda dapat menghitung ini menggunakan salah satu dari dua metode umum:
                </p>
                <ul>
                  <li>Detak jantung maksimal = 220 - usia individu dalam tahun</li>
                  <li>
                    Detak jantung maksimal = 206.9 - (0.67 × usia individu dalam tahun)
                  </li>
                </ul>
                Metode pertama lebih mudah dibandingkan metode kedua, tetapi metode kedua dianggap lebih akurat.
                <div>
                  <br />
                </div>
                <p>
                  Rentang detak jantung ideal saat berolahraga tergantung pada intensitas latihan. Berikut beberapa rentang yang direkomendasikan:
                </p>
                <ul>
                  <li>Latihan ringan: 57% - 63%</li>
                  <li>Latihan sedang: 64% - 76%</li>
                  <li>Latihan aerobik: 70% - 80%</li>
                  <li>Latihan intensitas tinggi: 77% - 95%</li>
                  <li>Latihan maksimal: 96% - 100%</li>
                </ul>
                <p>
                  Kalkulator ini dikembangkan berdasarkan{" "}
                  <a
                    href="https://www.heartonline.org.au/resources/calculators/target-heart-rate-calculator"
                    rel="nofollow"
                  >
                    National Heart Foundation of Australia
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div >
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="age">
                        Masukkan usia Anda
                      </label>
                      <input
                        id="age"
                        type="number"
                        value={age}
                        onChange={(e) => setAge(e.target.value)}
                        placeholder="Masukkan usia Anda"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="intensity">
                        Pilih intensitas latihan
                      </label>
                      <select
                        id="intensity"
                        value={intensity}
                        onChange={(e) => setIntensity(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        {[...Array(101).keys()].map((value) => (
                          <option key={value} value={value}>
                            {value}
                          </option>
                        ))}
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Hitung
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Kesalahan: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Hasil:</h4>
                      <p className="text-white">
                        Detak jantung pada tingkat ini: {result.targetHeartRate} detak per menit
                      </p>
                      <p className="text-white">
                        Rentang target yang direkomendasikan: {result.lowerBound} hingga {result.upperBound} detak per menit
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Informasi Tambahan</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Apa itu detak jantung ideal?
                    </h2>{" "}
                  </u>
                  <p>
                    Detak jantung ideal adalah detak jantung yang harus dicapai saat berolahraga untuk mendapatkan manfaat maksimal dari aktivitas fisik.
                  </p>
                  <div className="p-3 mb-2 bg-info ">
                    Contoh: Seseorang berusia 25 tahun dengan intensitas latihan 50% memiliki detak jantung sekitar 97 detak per menit.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Bagaimana detak jantung dihitung?
                    </h2>{" "}
                  </u>
                  <p>
                    Detak jantung ideal dihitung berdasarkan usia dan intensitas latihan Anda. Dokter dan pelatih menggunakan perhitungan ini untuk menentukan intensitas yang tepat bagi Anda.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Anda dapat menghitung detak jantung maksimal menggunakan salah satu dari dua metode umum: Detak jantung maksimal = 220 - usia individu dalam tahun, atau Detak jantung maksimal = 206.9 - (0.67 × usia individu dalam tahun)
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default HeartbeatCalculator;